import { Alert } from '@mui/material';
import { CREDITINFO } from '../../theme/constants';
import { getCreditIdentification, getRemainingCredits } from '../../store/selectors/selectors';
import { connect } from 'react-redux';
import { EXTERNALPRODUCTPAGE } from '../../config/environment';

function CreditInfo(props) {
  const { creditIdentification, remainingCredits } = props;

  const getSeverity = () => {
    if (remainingCredits <= 0 || creditIdentification.isExpired) return 'error';
    if (remainingCredits <= 10) return 'warning';
    return 'info';
  };

  const getCreditInfoText = () => {
    if (creditIdentification.isExpired) return CREDITINFO.EXPIRED_CREDITS;
    if (remainingCredits <= 0) return CREDITINFO.NO_CREDITS;
    if (remainingCredits <= 10) return remainingCredits + CREDITINFO.LOW_CREDITS;
    return remainingCredits + CREDITINFO.INFO_CREDITS;
  };

  return creditIdentification != null && !creditIdentification.hasPaidSubscription ? (
    <>
      <div>
        <Alert severity={getSeverity()}>
          {getCreditInfoText()}
          <br />
          <a href={EXTERNALPRODUCTPAGE} target="_new">
            Go to Portomundi Product Page
          </a>
        </Alert>
      </div>
    </>
  ) : (
    ''
  );
}

function mapStateToProps(state) {
  return {
    creditIdentification: getCreditIdentification(state),
    remainingCredits: getRemainingCredits(state),
  };
}

export default connect(mapStateToProps, null)(CreditInfo);
